import { bootstrapWidget } from "../../common";
import SpecsWidget from "./widget";

bootstrapWidget({ widget: SpecsWidget, widgetType: "specs" });
